import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateEnteredSeats } from '../redux/seatInfoSlice';
import toast from 'react-hot-toast';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import Services from '../services/services';
import { isAlphabet, isEmail } from './../regexFuncs';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    backgroundColor: '#E0E0F8',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginTop: theme.spacing(0.2),
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    borderRadius: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  seatNoCont: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  nameInput: {
    minWidth: 220,
    padding: theme.spacing(1),
    marginBottom: 2,
    marginTop: 2,
    borderWidth: 0,
    borderRadius: theme.spacing(1),
    outline: 'none',
    flex: 1,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));

function EnterSeatDetail({
  seat,
  boxId,
  eventId,
  // isHavingSeatPrice,
  // isPaymentReq,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [emailHasSeat, setEmailHasSeat] = useState(false);

  const checkEmailHasSeat = async (emailId, eventId, boxId) => {
    try {
      const res = await Services.check_is_email_has_seat(
        emailId,
        eventId,
        boxId
      );
      if (res.data.responseCode === 404) {
        setEmailHasSeat(false);
      } else {
        setEmailHasSeat(true);
      }
    } catch (error) {
      setEmailHasSeat(true);
      toast.dismiss();
      toast.error('Please check your internet connection!');
    }
  };

  const onChangeName = (e) => {
    const value = e.target.value;
    if (value === '' || (isAlphabet(value) && value.length <= 16)) {
      setName(value);
    }
  };

  const onChangeEmail = (e) => {
    const value = e.target.value.trim();
    setEmail(value);
    if (isEmail(value)) {
      checkEmailHasSeat(value, eventId, boxId);
    }
  };

  useEffect(() => {
    if (!emailHasSeat) {
      const seatFullDetail = {
        ...seat,
        isSeatAssign: 'Y',
        boxId: boxId,
        name: name,
        email: email,
        eventId: eventId,
        paymentStatus: 'N',
        userStreamingUrlId: 1,
        userChatId: 1,
        userId: 1,
      };
      dispatch(updateEnteredSeats({ seatFullDetail }));
    } else {
      const seatFullDetail = {
        ...seat,
        isSeatAssign: 'Y',
        boxId: boxId,
        name: name,
        email: '',
        eventId: eventId,
        paymentStatus: 'N',
        userStreamingUrlId: 1,
        userChatId: 1,
        userId: 1,
      };
      dispatch(updateEnteredSeats({ seatFullDetail }));
    }
  }, [name, email, emailHasSeat]);

  return (
    <Container>
      <form className={classes.container}>
        <div className={classes.seatNoCont}>
          <Typography variant='caption'>Seat No.</Typography>
          <Typography variant='button'>{seat.seatName}</Typography>
        </div>
        <input
          className={classes.nameInput}
          placeholder='Full name'
          value={name}
          onChange={onChangeName}
          // onKeyUp={handleEnter}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <input
            className={classes.nameInput}
            placeholder='Email'
            value={email}
            onChange={onChangeEmail}
            // onKeyUp={handleEnter}
          />
          {emailHasSeat && (
            <Typography variant='caption' color='error' display='inline'>
              This email has already reserved seat
            </Typography>
          )}
        </div>
      </form>
    </Container>
  );
}

export default EnterSeatDetail;
